import axios from 'axios';

let prefix = "/farming"

const FarmingLevelApi = {
	listFarmingLevel(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getFarmingLevelInfo(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	archiveFarmingLevel(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createFarmingLevel(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateFarmingLevel(payload) {
		return axios.post(prefix + "/update", payload)
	},
	getFarmingTypeOptions(payload) {
		return axios.get(prefix + "/farming-type-options", { params: payload })
	},
}

export default FarmingLevelApi;